import React from "react"
import ComponentWithData from "~/utils/ComponentWithData"

import {Area} from "~/utils/ShelfEntities"

import {
  List,
  DetailInfoRow,
  ListItemLocation,
  Button,
  DownloadButton
} from "~/components/"
import {withTranslation} from "react-i18next"

class AreaDetailView extends ComponentWithData {
  getData() {
    return Area.find(this.props.match.params.area_id)
  }
  renderLoading() {
    return <p>{this.props.t("loading")}</p>
  }
  renderError() {
    return (
      <p>
        {this.props.t("error")} {console.log(this.state.error)}
      </p>
    )
  }
  renderEmpty() {
    return <p>{this.props.t("zones.noZone")}</p>
  }
  renderWithData() {
    return (
      <div className="sh-detail-view">
        <div className="header">
          <div className="title">{this.props.t("zones.title")}</div>
          <div className="actions">
            <DownloadButton
              label={this.props.t("zones.detail.downloadArticles", {
                format: "(.xlsx)"
              })}
              endpoint={`/areas/${this.state.data.id}/articles.xlsx`}
              filename={`area_${this.state.data.id}_articles.xlsx`}
              mimeType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            />
            <DownloadButton
              label={this.props.t("zones.detail.downloadArticles", {
                format: "(.csv)"
              })}
              endpoint={`/areas/${this.state.data.id}/articles.csv`}
              filename={`area_${this.state.data.id}_articles.csv`}
              mimeType="text/csv"
            />
            <Button
              primary
              to={"/areas/" + this.state.data.id}
              label={this.props.t("edit")}
            />
          </div>
        </div>
        <div>
          <DetailInfoRow
            label={this.props.t("zones.detail.name")}
            value={this.state.data.name}
          />
          <DetailInfoRow
            label={this.props.t("zones.detail.includeInReports")}
            value={
              this.state.data.include_in_reports
                ? this.props.t("yes")
                : this.props.t("no")
            }
          />

          <DetailInfoRow label={this.props.t("zones.detail.locations")}>
            <List
              items={this.state.data.locations}
              itemRenderer={ListItemLocation}
            >
              <div className="empty">
                {this.props.t("zones.detail.noLocationsInZone")}
              </div>
            </List>
          </DetailInfoRow>
        </div>
      </div>
    )
  }
}

export default withTranslation()(AreaDetailView)



// WEBPACK FOOTER //
// ./src/views/detail/AreaDetailView.js